import {defineStore} from 'pinia'
import {useComponentsStore} from '@/stores/components'
import {useItemDataStore} from '@/stores/itemData'

export const useDocumentTitleStore = defineStore('documentTitle', {
    state: () => ({}),
    
    actions: {
        set({stateName, tableName, itemId}) {
            switch (stateName) {
                case 'dashboard':
                    this.setDocumentTitle('Dashboard')
                    break
                
                case 'siteTreePanes':
                    this.setDocumentTitle('Site tree')
                    break
                
                case 'themesEditor':
                    this.setDocumentTitle('Editor')
                    break
                
                case 'list':
                case 'form': {
                    const componentsStore = useComponentsStore()
                    const itemDataStore = useItemDataStore()
                    let component = componentsStore.items.find(o => o.tableName === tableName)
                    
                    if (!component) {
                        return
                    }
                    
                    let title = component.title
                    
                    if (!itemId) {
                        this.setDocumentTitle(title)
                        return
                    }
                    
                    return itemDataStore.get({
                            tableName: tableName,
                            id: itemId,
                        })
                        .then((obj) => {
                            if (obj) {
                                const nameField = componentsStore.nameField(component.id)
                                
                                let itemTitle = obj[nameField]
                                if (itemTitle) {
                                    title = itemTitle + ' / ' + title
                                }
                                
                                this.setDocumentTitle(title)
                            } else {
                                this.setDocumentTitle(title)
                            }
                        })
                }
            }
        },
        
        setDocumentTitle(title) {
            window.document.title = title
        }
    }
})